import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-select-mfa',
  templateUrl: './select-mfa.component.html',
  styleUrls: ['./select-mfa.component.css']
})
export class SelectMfaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
